<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluation/components/Autoevaluation/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>